import React, { useState, useEffect, useRef } from "react";

const ButtonRange = ({ id, min = 0, max = 100, defaultValue = min }) => {
	const [value, setValue] = useState(defaultValue);
	const componentRef = useRef(null);

	// Expose methods to the DOM
	useEffect(() => {
		if (componentRef.current) {
			componentRef.current.getValue = () => value;
			componentRef.current.setValue = (newValue) => {
				const parsedValue = parseInt(newValue, 10);
				if (!isNaN(parsedValue)) {
					setValue(Math.max(min, Math.min(parsedValue, max)));
				}
			};
		}
	}, [value, min, max]);

	// Handle "Add" button
	const handleAdd = () => {
		setValue((prev) => Math.min(prev + 1, max));
	};

	// Handle "Remove" button
	const handleRemove = () => {
		setValue((prev) => Math.max(prev - 1, min));
	};

	// Handle input change
	const handleInputChange = (e) => {
		let newValue = parseInt(e.target.value, 10);
		if (isNaN(newValue)) {
			newValue = 0; // If the input is invalid (e.g., empty), set it to 0
		}
		setValue(Math.max(min, Math.min(newValue, max))); // Clamp the value
	};

	return (
		<div ref={componentRef} id={id} className="flex items-center gap-1">
			<button
				className="btn min-h-[24px] p-0 aspect-square"
				onClick={handleRemove}
				aria-label="Decrease value"
			>
				<span className="text-lg font-MaterialIcons">Remove</span>
			</button>

			<input
				type="number"
				className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none w-12 text-center border-grey rounded-primary border-thin p-1 text-xs"
				value={value}
				onChange={handleInputChange}
				min={min}
				max={max}
				step={1}
				aria-live="polite" // Ensure real-time updates are announced
			/>

			<button
				className="btn min-h-[24px] p-0 aspect-square"
				onClick={handleAdd}
				aria-label="Increase value"
			>
				<span className="text-lg font-MaterialIcons">Add</span>
			</button>
		</div>
	);
};

export default ButtonRange;
